module.exports = __webpack_public_path__ + "img/active-23.87ed6da9.svg";